<app-layout *ngIf="file" mathjax>


  <header class="hero--file">
    <app-base-section>
      <div class="breadcrumbs">
        <a
          *ngIf="breadcrumbTopicRoute && !isOtherTopic"
          [routerLink]="breadcrumbTopicRoute"
          class="link link--sm breadcrumbs__link" [ngClass]="file.topic">
          <span class="icon icon-chevron-sm icon--rotate-right"></span><span
          class="link__text">{{'Common.Library.' + file.topic|translate}}</span>
        </a>
        <div
          class="breadcrumbs__wrap"
          [ngClass]="{'active': active}"
          *ngIf="breadcrumbElements && breadcrumbElements.length">
          <span class="breadcrumbs__wrap__overlay" *ngIf="active" (click)="onClick()"></span>
          <a class="breadcrumbs__expand chover" (click)="onClick()">
            <span class="icon icon-ellipsis breadcrumbs__icon"></span>
          </a>
          <div class="breadcrumbs__menu">
            <button class="breadcrumbs__menu__close" (click)="onClick()">
              <span class="icon icon-close-sm"></span>
            </button>
            <ul >
              <li *ngFor="let child of breadcrumbElements">
                <a
                  [routerLink]="child.routerLink"
                  (click)="onClick()"
                  class="body--2"
                ><span class="icon icon-arrow-bend breadcrumbs__menu__icon"></span>
                  <span class="breadcrumbs__menu__text">{{ child.title }}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </app-base-section>

    <app-base-section [isNarrow]="true">
      <div class="hero__tags">
        <div class="hero__tags__container">
          <app-tag-list
            *ngIf="file.tags"
            [hub]="file.topic"
            [tags]="file.tags"
            [buttonBehaviour]= "'nav'"
            ></app-tag-list>

        </div>

        <div class="file__top__social">
          <app-sharer></app-sharer>
        </div>
      </div>
      <h1 class="title title--h1 hero__title">{{file.title}}</h1>
      <div class="hero__text" *ngIf="file.introduction">
        <app-wysiwyg-content [content]="file.introduction"></app-wysiwyg-content>
      </div>
      <div class="hero__caption" *ngFor="let level of levels">
        <span class="caption">{{level.label}}</span>
        <span class="hero__caption__years">{{level.years}}</span>
      </div>
    </app-base-section>

  </header>

  <div class="file-content">
    <div
      [attr.id]="section.slug || null"
      [attr.data-ancnav]="section.slug || null"
      [attr.data-bg-color]="(si+1) % 2 ? null : '50'"
      class="content-section"
      *ngFor="let section of file.sections; let si = index"
    >
      <app-base-section
        [isNarrow]="true"
        [isWrapping]="'section-title'"
        *ngIf="section.title"
      >
        <h2 class="title title--h2 content-section__title">{{section.title}}</h2>
      </app-base-section>

      <app-base-section
        *ngFor="let module of section.modules; let mi = index"
        [isNarrow]="true"
        [module]="module"
        [isFirst]="mi === 0 && !section.title"
        [isLast]="mi + 1 === section.modules.length"
      >
        <app-bloc-special *ngIf="module.type === 'blocSpecial'" [module]="module"></app-bloc-special>
        <app-links-module *ngIf="module.type === 'tableOfContents'" [module]="module"></app-links-module>
        <app-multi-column *ngIf="module.type === 'multiColumn'" [module]="module"></app-multi-column>
        <app-image *ngIf="module.type === 'media'" [module]="module"></app-image>
        <app-video *ngIf="module.type === 'youtube'" [module]="module"></app-video>
        <app-text *ngIf="module.type === 'text'" [module]="module"></app-text>
        <app-exercise *ngIf="module.type === 'exerciseList'" [module]="module"></app-exercise>
        <app-links-module *ngIf="module.type === 'redirects'" [module]="module"></app-links-module>
        <app-vocabulary *ngIf="module.type === 'vocabulary'" [module]="module"></app-vocabulary>
      </app-base-section>
    </div>

    <!-- Static section for references, commentaries, file completion, etc.   -->
    <div
      class="file-section"
      *ngIf="file.references && (file.references.texts.length || file.references.links.length)"
    >
      <app-base-section
        [isNarrow]="true"
      >
        <app-references
          [references]="file.references"
        ></app-references>
      </app-base-section>
    </div>
  </div>

  <app-anchor-navigation
    *ngIf="file.navigation && file.navigation.length"
    [navigation]="file.navigation"
  ></app-anchor-navigation>

</app-layout>
